<div class="header">
    <div class="container-fluid ps-0 pe-0">
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex h-100 align-items-center">
                <span class="names">{{ firstName }} {{ lastName }}</span>
            </div>
            <!-- Environment Selector -->
           <!--  @if (canSwapBaseUrl) {
                <div class="d-flex justify-content-end w-100">
                    <li
                        class="d-flex justify-content-around align-items-center environment-selector">
                        <input
                            id="baseUrl"
                            type="text"
                            class="form-control w-auto"
                            [(ngModel)]="newBaseUrl" />
                        <button
                            class="btn btn-text text-nowrap text-green no--padding"
                            (click)="onSwapEnvClick()">
                            Change Env
                        </button>
                        <button
                            class="btn btn-text text-nowrap text-red no--padding"
                            (click)="onResetEnvClick()">
                            Reset Env
                        </button>
                    </li>
                </div>
            } -->

            <ul
                class="header-actions d-flex align-items-center"
                (click)="changeNavState(false)">
                
                <li class="abr">
                    <account-settings></account-settings>
                </li>
            </ul>
        </div>
    </div>
</div>
